<template>
<div id="app">
  <div id="gallery" class="overflow-hidden">
    <div class="g-container position-relative">
      <div class="g-wrapper"><!--id="wannabe-fs" -->
        <div class="g-inner-wrapper">
            <transition name="fadeIn" mode="out-in" @after-leave="checkNextImage">
                <img v-if="isReadyImg && nextImageState" :src="currImg.src" :alt="currImg.alt" :key="currImg.id" @click="toggleFullScreen" :class="currImg.class">
            </transition>
        </div>
          <div v-if="showFs" class="control-right">
              <div class="control-inner" style="opacity: 1;">
                  <svg @click="nextImg" width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg" style="cursor: pointer;">
                      <circle cx="22.5" cy="22.5" r="22.5" fill="#E5E4E4"/>
                      <path d="M33.4142 24.4142C34.1953 23.6332 34.1953 22.3668 33.4142 21.5858L20.6863 8.85786C19.9052 8.07682 18.6389 8.07682 17.8579 8.85786C17.0768 9.63891 17.0768 10.9052 17.8579 11.6863L29.1716 23L17.8579 34.3137C17.0768 35.0948 17.0768 36.3611 17.8579 37.1421C18.6389 37.9232 19.9052 37.9232 20.6863 37.1421L33.4142 24.4142ZM28 25L32 25L32 21L28 21L28 25Z" fill="#0C0C0C" fill-opacity="0.76"/>
                  </svg>
              </div>
          </div>
          <div v-if="showFs" class="control-left">
              <div class="control-inner" style="opacity: 1;">
                  <svg @click="prevImg" width="46" height="45" viewBox="0 0 46 45" fill="none" xmlns="http://www.w3.org/2000/svg" style="cursor: pointer;">
                      <circle cx="23.2998" cy="22.5" r="22.5" transform="rotate(-180 23.2998 22.5)" fill="#E5E4E4"/>
                      <path d="M12.3846 20.5858C11.6036 21.3668 11.6036 22.6332 12.3846 23.4142L25.1125 36.1421C25.8936 36.9232 27.1599 36.9232 27.941 36.1421C28.722 35.3611 28.722 34.0948 27.941 33.3137L16.6273 22L27.941 10.6863C28.722 9.90524 28.722 8.63891 27.941 7.85786C27.1599 7.07682 25.8936 7.07682 25.1125 7.85786L12.3846 20.5858ZM17.7988 20L13.7988 20L13.7988 24L17.7988 24L17.7988 20Z" fill="#0C0C0C" fill-opacity="0.76"/>
                  </svg>
              </div>
          </div>
      </div>
      <div class="g-controls-wrapper">
        <div class="control-top" style="z-index: 13!important;">
          <div class="control-inner">
              <nav class="position-fixed navbar navbar-light justify-content-start" style="top: 0; left: 0; z-index: 10; width: 100%; background-color: #0000007a;">
                  <div class="d-flex flex-row align-items-center position-relative" style="width: 15%; z-index: 1;">
                      <router-link to="/" class="navbar-brand" style="height: 100%;"><img :src="require('../assets/static/Brand_xl_white.png')" alt="Katarina di Maladel" style="width: auto; height: 60px;"></router-link>
                  </div>
                  <div class="collapse-icon" data-toggle="collapse" data-target="#navbarSupportedContent">
                      <button>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="rgb(255, 255, 255)" viewBox="0 0 16 16">
                              <path d="M3.626 6.832A.5.5 0 0 1 4 6h8a.5.5 0 0 1 .374.832l-4 4.5a.5.5 0 0 1-.748 0l-4-4.5z"/>
                              <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2z"/>
                          </svg>
                      </button>
                  </div>
                  <div class="no-collapse-content flex-row align-items-center justify-content-end" style="width: 85%; height: 100%;">
                      <router-link class="nav-link" to="stancija" data-value="Stancija">{{webData.nav[1]}}</router-link>
                      <router-link class="nav-link" to="services" data-value="Services">{{webData.nav[2]}}</router-link>
                      <router-link class="nav-link" to="experience" data-value="Experience">{{webData.nav[3]}}</router-link>
                      <router-link class="nav-link" to="gallery" data-value="Gallery">{{webData.nav[4]}}</router-link>
                      <div class="dropdown">
                          <a class="nav-link drop-btn" data-value="Lang">{{$store.getters.getLang}}
                              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="rgb(255, 255, 255)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                  <path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                              </svg>
                          </a>
                          <div class="dropdown-content">
                              <a @click="$emit('set-lang', 'eng')">ENG</a>
                              <a @click="$emit('set-lang', 'de')">DE</a>
                              <a @click="$emit('set-lang', 'hrv')">HRV</a>
                          </div>
                      </div>
                      <router-link class="nav-link" to="book" data-value="Contact Us">{{webData.nav[6]}}</router-link>
                  </div>
                  <div id="navbarSupportedContent" class="collapse navbar-collapse position-absolute" style="top: 0; left: 0; background-color: #f7f7f7; color: #0C0C0C; width: 100%; height: 100vh;">
                      <div class="position-relative nav-ova-background d-flex flex-row align-items-center" style="width: 100%; height: 100vh;">
                          <ul class="navbar-nav mr-auto text-center" style="color: inherit; padding: 40px 0 40px 0; width: 100%;">
                              <li id="home-link" class="nav-item active">
                                  <router-link class="nav-link color-b" to="/" data-value="Home" data-toggle="collapse" data-target="#navbarSupportedContent">{{webData.nav[0]}}</router-link>
                              </li>
                              <li id="accommodation-link" class="nav-item active">
                                  <router-link class="nav-link color-b" to="stancija" data-value="Stancija" data-toggle="collapse" data-target="#navbarSupportedContent">{{webData.nav[1]}}</router-link>
                              </li>
                              <li id="story-link" class="nav-item active">
                                  <router-link class="nav-link color-b" to="services" data-value="Services" data-toggle="collapse" data-target="#navbarSupportedContent">{{webData.nav[2]}}</router-link>
                              </li>
                              <li id="gallery-link" class="nav-item active">
                                  <router-link class="nav-link color-b" to="experience" data-value="Experience" data-toggle="collapse" data-target="#navbarSupportedContent">{{webData.nav[3]}}</router-link>
                              </li>
                              <li id="gallery-link" class="nav-item active">
                                  <router-link class="nav-link color-b" to="gallery" data-value="Gallery" data-toggle="collapse" data-target="#navbarSupportedContent">{{webData.nav[4]}}</router-link>
                              </li>
                              <li class="dropdown nav-item">
                                  <a class="nav-link drop-btn drop-btn-mobile color-b" data-value="Lang">{{webData.nav[5]}}
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="rgb(0, 0, 0)" viewBox="0 0 16 16">
                                          <path d="M3.626 6.832A.5.5 0 0 1 4 6h8a.5.5 0 0 1 .374.832l-4 4.5a.5.5 0 0 1-.748 0l-4-4.5z"/>
                                      </svg>
                                  </a>
                                  <div class="dropdown-content dropdown-content-mobile">
                                      <a @click="$emit('set-lang', 'eng')">Eng</a>
                                      <a @click="$emit('set-lang', 'de')">De</a>
                                      <a @click="$emit('set-lang', 'hrv')">Hrv</a>
                                  </div>
                              </li>
                              <li id="contact-link" class="nav-item active">
                                  <router-link class="nav-link color-b" to="book" data-value="Book" data-toggle="collapse" data-target="#navbarSupportedContent">{{webData.nav[6]}}</router-link>
                              </li>
                          </ul>
                      </div>
                  </div>
              </nav>
          </div>
        </div>
        <div class="control-right">
          <div class="control-inner">
            <svg @click="nextImg" width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg" style="cursor: pointer;">
              <circle cx="22.5" cy="22.5" r="22.5" fill="#E5E4E4"/>
              <path d="M33.4142 24.4142C34.1953 23.6332 34.1953 22.3668 33.4142 21.5858L20.6863 8.85786C19.9052 8.07682 18.6389 8.07682 17.8579 8.85786C17.0768 9.63891 17.0768 10.9052 17.8579 11.6863L29.1716 23L17.8579 34.3137C17.0768 35.0948 17.0768 36.3611 17.8579 37.1421C18.6389 37.9232 19.9052 37.9232 20.6863 37.1421L33.4142 24.4142ZM28 25L32 25L32 21L28 21L28 25Z" fill="#0C0C0C" fill-opacity="0.76"/>
            </svg>
          </div>
        </div>
        <div class="control-bottom">
          <div class="control-inner">
            <div class="filter-item-wrapper">
                <div class="filter-item-wrapper-inner">
                    
                    <div class="filter-item" @click="filterImages(1)">
                        <div class="bg-item-img-outside"></div>
                        <div @click="activeIndex=1" :class="[activeIndex===1 ? 'activeIndex' : '']" class="filter-item-overlay">
                            <h5 style="font-size:14px !important">{{webData.filters[0]}}</h5>
                        </div>
                    </div>
                    <div class="filter-item" @click="filterImages(2)">
                        <div class="bg-item-img-kitchen"></div>
                        <div @click="activeIndex=2" :class="[activeIndex===2 ? 'activeIndex' : '']" class="filter-item-overlay">
                            <h5 style="font-size:14px !important">{{webData.filters[1]}}</h5>
                        </div>
                    </div>
                    <div class="filter-item" @click="filterImages(3)">
                        <div class="bg-item-img-living-room"></div>
                        <div @click="activeIndex=3" :class="[activeIndex===3 ? 'activeIndex' : '']" class="filter-item-overlay">
                            <h5 style="font-size:14px !important">{{webData.filters[2]}}</h5>
                        </div>
                    </div>
                    <div class="filter-item" @click="filterImages(4)">
                        <div class="bg-item-img-bedrooms"></div>
                        <div @click="activeIndex=4" :class="[activeIndex===4 ? 'activeIndex' : '']" class="filter-item-overlay">
                            <h5 style="font-size:14px !important">{{webData.filters[3]}}</h5>
                        </div>
                    </div>
                    <div class="filter-item" @click="filterImages(5)">
                        <div class="bg-item-img-bathrooms"></div>
                        <div @click="activeIndex=5" :class="[activeIndex===5 ? 'activeIndex' : '']" class="filter-item-overlay">
                            <h5 style="font-size:14px !important">{{webData.filters[4]}}</h5>
                        </div>
                    </div>
                    <div class="filter-item" @click="filterImages(6)">
                        <div class="bg-item-img-entertainment"></div>
                        <div @click="activeIndex=6" :class="[activeIndex===6 ? 'activeIndex' : '']" class="filter-item-overlay">
                            <h5 style="font-size:14px !important" class="entertainment-font">{{webData.filters[5]}}</h5>
                        </div>
                    </div>
                    <div class="filter-item" @click="filterImages(7)">
                        <div class="bg-item-img-outside"></div>
                        <div @click="activeIndex=7" :class="[activeIndex===7 ? 'activeIndex' : '']" class="filter-item-overlay">
                            <h5 style="font-size:14px !important">{{webData.filters[6]}}</h5>
                        </div>
                    </div>
                    <div class="filter-item" @click="filterImages(8)">
                        <div class="bg-item-img-events"></div>
                        <div @click="activeIndex=8" :class="[activeIndex===8 ? 'activeIndex' : '']" class="filter-item-overlay">
                            <h5 style="font-size:14px !important">{{webData.filters[7]}}</h5>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
        <div class="control-left">
          <div class="control-inner">
            <svg @click="prevImg" width="46" height="45" viewBox="0 0 46 45" fill="none" xmlns="http://www.w3.org/2000/svg" style="cursor: pointer;">
              <circle cx="23.2998" cy="22.5" r="22.5" transform="rotate(-180 23.2998 22.5)" fill="#E5E4E4"/>
              <path d="M12.3846 20.5858C11.6036 21.3668 11.6036 22.6332 12.3846 23.4142L25.1125 36.1421C25.8936 36.9232 27.1599 36.9232 27.941 36.1421C28.722 35.3611 28.722 34.0948 27.941 33.3137L16.6273 22L27.941 10.6863C28.722 9.90524 28.722 8.63891 27.941 7.85786C27.1599 7.07682 25.8936 7.07682 25.1125 7.85786L12.3846 20.5858ZM17.7988 20L13.7988 20L13.7988 24L17.7988 24L17.7988 20Z" fill="#0C0C0C" fill-opacity="0.76"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
var app = new Vue({
  el: '#app',
  data: {
    activeIndex: 0
  }
})
export default {
  name: "Gallery",
    props: {
        webDataGlobal: {
            type: Object,
            required: true
        }
    },
    
    data () {
      return {
          currImg: null,
          currIndex: 0,
          isReadyImg: false,
          nextImageState: true,
          isFilterActive: false,
          filteredImages: [],
          activeFilter: '',
          showFs: false,
          webData: {}
      }
    },
    created () {
        this.webData = this.webDataGlobal.gallery;
      this.$emit('set-nav-state', false);
      this.currImg = this.$store.getters.getGalleryImage;
      if (this.isFunction(this.currImg.src))    this.getImageSource();
      else this.isReadyImg = true;
    },
    mounted () {
        let a = document.getElementsByClassName('filter-item-overlay');
        this.activeFilter = a[0];
        
    },
    methods: {
        toggleFullScreen () {
            let el = document.querySelector('#wannabe-fs');
            if (this.showFs) {
                el.classList.remove('full-screen');
                this.showFs = false;
            } else {
                el.classList.add('full-screen');
                this.showFs = true;
            }
        },
      isFunction(functionToCheck) {
          let getType = {};
          return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
      },
      async getImageSource () {
          let c = await this.currImg.src();
          this.currImg.src = c.default;
          this.currImg.src = '';
          this.currImg.src = c.default;
          this.isReadyImg = true;
          this.$store.commit('setImageSource', this.currImg.src);
      },
        nextImg () {
          this.isReadyImg = this.nextImageState = false;
          if (this.currIndex < this.getGalleryLength - 1) {
              this.currIndex++;
              this.updateCurrentImage();
          } else {
              this.currIndex = 0;
              this.updateCurrentImage();
          }
        },
        prevImg () {
          this.isReadyImg = this.nextImageState = false;
          if (this.currIndex > 0) {
              this.currIndex--;
              this.updateCurrentImage();
          } else {
              this.currIndex = this.getGalleryLength - 1;
              this.updateCurrentImage();
          }
        },
        async updateCurrentImage () {
          if (this.isFilterActive) {
              this.currImg = this.filteredImages[this.currIndex];
              let index = await this.$store.dispatch('getIndexOfImage', this.currImg);
              this.$store.commit('setGalleryIndex', index);
          } else {
              this.$store.commit('setGalleryIndex', this.currIndex);
              this.currImg = this.$store.getters.getGalleryImage;
          }
          if (this.isFunction(this.currImg.src))  {
              await this.getImageSource();
          }
          else this.isReadyImg = true;
        },
       async filterImages (blockNumber) {
              console.log("Block number: ",blockNumber)
              this.isReadyImg = this.nextImageState = false;
              this.isFilterActive = true;
              this.$store.commit('setGalleryFilterNumber', blockNumber);
              this.filteredImages = await this.$store.getters.getGalleryFilter;
              /*console.log(this.filteredImages)*/
              this.currImg = this.filteredImages[1];
              if (this.isFunction(this.currImg.src))  {
                  let index = await this.$store.dispatch('getIndexOfImage', this.currImg);
                  this.$store.commit('setGalleryIndex', index);
                  await this.getImageSource();
              }
              else this.isReadyImg = true;
          
          let e = event.target;
          this.setActiveFilter(e);
        },

        /*
         async filterImages (blockNumber) {
          if (blockNumber === 1) {
              this.isFilterActive = false;
                     
              this.isReadyImg = this.nextImageState = false;
             
              

              this.filteredImages = await this.$store.getters.getGalleryAll;

              this.currImg = this.filteredImages[0];
              console.log("Block number",this.filteredImages, "CURR IMG",this.currImg)
                
                  if (this.isFunction(this.currImg.src))  {
                    let index = await this.$store.dispatch('getIndexOfImage', this.currImg);
                    this.$store.commit('setGalleryIndex', index);
                    await this.getImageSource();
                  }
                  
              this.isReadyImg = true;
              
          } else {
              this.isReadyImg = this.nextImageState = false;
              this.isFilterActive = true;
              this.$store.commit('setGalleryFilterNumber', blockNumber);
              
              this.filteredImages = await this.$store.getters.getGalleryFilter;
              this.currImg = this.filteredImages[0];
              
              if (this.isFunction(this.currImg.src))  {
                  
                  let index = await this.$store.dispatch('getIndexOfImage', this.currImg);
                  this.$store.commit('setGalleryIndex', index);
                  await this.getImageSource();
              }
              else this.isReadyImg = true;
              //console.log(this.currImg)
          //console.log("GALLERY ALL",this.$store.getters.getGalleryAll, "FILTER",this.$store.getters.getGalleryFilter)
          }
          let e = event.target;
          this.setActiveFilter(e);
        },
        */

        setActiveFilter (newElement) {
          this.activeFilter.classList.remove('active');
          if (newElement.tagName === 'H5')  newElement.parentElement;
          else    this.activeFilter = newElement;
          this.activeFilter.classList.add('active');
        },
        checkNextImage () {
            this.nextImageState = true;
        }
    },
    computed: {
      getGalleryLength () {
          if (this.isFilterActive)  return this.filteredImages.length;
          else return 9;
      }
    },
    beforeDestroy() {
        this.$emit('set-nav-state', true);
    }
}
</script>

<style scoped>
#gallery {
  width: 100%;
  height: 100vh;
  position: relative;
}
.g-container, .g-wrapper {
  height: inherit;
  width: inherit;
}
.g-inner-wrapper img.width {
    width: 100%;
    height: auto;
}
.g-inner-wrapper img.height {
    width: auto;
    height: 100%;
}
.g-wrapper {
  background-color: #0c0c0c;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.g-controls-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  border: none;
  z-index: 10;
    pointer-events: none;
}
.control-top, .control-right, .control-bottom, .control-left {
  position: absolute;
  background: transparent;
  z-index: 11;
    pointer-events: all;
}
.control-top:hover .control-inner, .control-right:hover .control-inner, .control-bottom:hover .control-inner, .control-left:hover .control-inner {
  opacity: 1;
}
.control-top, .control-bottom {
  /*height: 120px;*/
  width: 100%;
    z-index: 12!important;
}
.control-right, .control-left {
  height: 100%;
  width: 120px;
}
.control-top, .control-left {
  left: 0;
  top: 0;
}
.control-bottom {
  left: 0;
  bottom: 0;
}
.control-right {
  top: 0;
  right: 0;
}
.control-inner {
  height: inherit;
  width: inherit;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  opacity: 1;
  transition: 500ms ease-out;
}
.entertainment-font{
    font-size: 14px !important;
}
@media (max-width: 992px) {
    .control-inner {
        opacity: 1;
    }
}
@media (min-width: 768px) {
    .filter-item-wrapper {
        width: 100%;
        overflow-y: hidden;
    }
    .filter-item-wrapper-inner {
        margin: 0 auto;
    }
}
@media (max-width: 768px) {
    .control-left .control-inner svg, .control-right .control-inner svg {
        width: 25px;
        height: 25px;
    }
    .control-left .control-inner svg {
        margin-left: -50px;
    }
    .control-right .control-inner svg {
        margin-right: -50px;
    }
    .filter-item-wrapper {
         width: auto;
         overflow-y: scroll;
    }
    .filter-item-wrapper-inner {
        margin: 0;
    }
}
.filter-item-wrapper-inner {
    width: 820px;
}
.filter-item {
  display: inline-block;
  height: 90px;
  width: 90px;
  position: relative;
  margin-right: 12px;
  margin-bottom: 10px;
  overflow: hidden;
  cursor: pointer;
  border-radius: 8px;
}
.bg-item-img-kitchen {
  height: inherit;
  width: inherit;
  background-image: url("../assets/static/Katarina_home_06.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.bg-item-img-living-room {
  height: inherit;
  width: inherit;
  background-image: url("../assets/static/Katarina_home_04.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.bg-item-img-bedrooms {
  height: inherit;
  width: inherit;
  background-image: url("../assets/static/Katarina_home_07.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.bg-item-img-bathrooms {
  height: inherit;
  width: inherit;
  background-image: url("../assets/static/Katarina_home_05.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.bg-item-img-entertainment {
  height: inherit;
  width: inherit;
  background-image: url("../assets/static/Katarina_home_08.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.bg-item-img-outside {
  height: inherit;
  width: inherit;
  background-image: url("../assets/static/Katarina_home_09.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.bg-item-img-outside {
  height: inherit;
  width: inherit;
  background-image: url("../assets/static/Katarina_home_09.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.bg-item-img-events {
height: inherit;
  width: inherit;
  background-image: url("../assets/images/gallery/katarina_events_10.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.filter-item-overlay {
    font-size: 20px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .3681);
  color: #ffffff;
  z-index: 2;
    transition: background-color 300ms ease-out;
}
.filter-item:hover .filter-item-overlay {
    background-color: rgba(0, 0, 0, .7291);
}
.activeIndex {
    background-color: rgba(0, 0, 0, .7291);
    z-index: 999999;
}
.full-screen {
    position: relative;
    z-index: 9999999;
}
</style>
